firebird.directive('notifyOnClick', [
    'growlService',
    'helperService',
    'localizationService',
    function (growlService, helperService, localizationService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.click(function () {
                    var notificationMsg = localizationService.translate('NOTIFICATIONS.COPIED_TO_CLIPBOARD');

                    if (helperService.getDeviceType() === 'iPad') {
                        helperService.mobileAlert(notificationMsg, null, '');
                    } else {
                        growlService.show(notificationMsg, 'success');
                    }
                });
            }
        };
    }
]);
